import React, { useState, useEffect } from "react"
import { useQuery } from "@apollo/client"
import { GetNearbyMapFeaturesQuery } from "../graphql/map"

const GetNearbyFeatures = ({
  render,
  distance,
  coordinates,
  isSkipping,
  isShowingOpenBeta,
}) => {
  const [nearbyFeatures, setNearbyFeatures] = useState(null)
  const {
    loading,
    error,
    data: { getNearbyMapFeatures } = {},
  } = useQuery(GetNearbyMapFeaturesQuery, {
    variables: {
      point: {
        type: "point",
        coordinates: coordinates && [
          Number(coordinates[0]),
          Number(coordinates[1]),
        ],
      },
      distance,
    },
    skip: !coordinates?.[0] || !distance || isSkipping,
  })
  useEffect(() => {
    if (
      !loading &&
      !error &&
      getNearbyMapFeatures &&
      // > 1 because has a __typename property
      Object.values(getNearbyMapFeatures).flat()?.length > 1
    ) {
      setNearbyFeatures(getNearbyMapFeatures)
    }
  }, [error, getNearbyMapFeatures, loading])

  return render({
    loading,
    error,
    getNearbyFeatures: nearbyFeatures,
  })
}

export default GetNearbyFeatures
